import dashboard from './dashboard';
import utilities from './departamento';
import proveedor from './proveedor';
import configuracion from './configuracion';
import retencion from './retencion';
import comprobante from './comprobante';
import reporte from './reporte';
import liquidacion from './liquidacionCompra';
import documento from './documento';
import Contabilizacion_AASSINet from './contabilizacion_EnlaceAASINet';
import Enlace_SIA from './enlace_SIA';
import compraIglesia from './compraIglesia';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        dashboard,
        configuracion,
        utilities,
        proveedor,
        documento,
        liquidacion,
        retencion,
        comprobante,
        reporte,
        // contabilizacion,   
        Contabilizacion_AASSINet,
        Enlace_SIA,
        compraIglesia
    ]
};

export default menuItems;
